var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.item
    ? _c("ItpFormSelect2", {
        attrs: {
          name: _vm.path,
          dataSource: _vm.b_7315092382398562_dataSource,
          prefetch: "",
          valueField: "id",
          textField: "name",
          "bind-object": "",
          multiple: _vm.multiple,
          clearable: _vm.clearable,
          autofocus: _vm.autofocus,
          disabled: _vm.readonly || _vm.item.isReadonly,
          readonly: _vm.readonly || _vm.item.isReadonly,
          required: _vm.required,
          optionTemplate:
            "<UcSuggestContractOption :option=option></UcSuggestContractOption>",
          "use-option-template-for-selected-option": ""
        },
        on: {
          optionSelected: function($event) {
            return _vm.evh_7315092382398562_optionSelected($event, {})
          }
        },
        model: {
          value: _vm.item[_vm.path],
          callback: function($$v) {
            _vm.$set(_vm.item, _vm.path, $$v)
          },
          expression: "item[path]"
        }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }